/**
 * This middleware captures actions and  handle custom events
 */
import { doShowPopup, doHidePopup } from 'Store/actions/popup'
import { doHideToast } from 'Store/actions/toast'
import appEnvRemap from 'Utility/appEnvRemap'
import { actionTypes as persistedActionTypes } from 'Store/actions/persistedActions'
import { flowPopupMapType } from 'Utility/flowPopupMap'
import { doLogout } from 'Store/actions/login'
import requestManager from 'Api/requestManager'
// import { doSaveAction } from 'Store/actions/global'

const REDIRECT_PATH_LOGIN = appEnvRemap.REDIRECT_PATH_LOGIN

const globals = store => next => action => {
  const isLoginPath = window.location.pathname === process.env.PATH_LOGIN
  const isLoginAppPath = window.location.pathname === '/login-app'

  if (action.type === '@@router/LOCATION_CHANGE' || (action.type === '@@popup/show_popup' && action.key !== 'OTP_MODAL')) {
    store.dispatch(doHideToast())
  }
  if (action.type === '@@router/LOCATION_CHANGE') {
    // Cancella tutte le richieste HTTP pending al cambio di rotta
    requestManager.cancelAllPending()

    const state = store.getState()
    if (state.popup && state.popup.popupKey) {
      store.dispatch(doHidePopup())
    }
  }
  if (/_FAILURE/i.test(action.type)) {
    // Ignora completamente gli errori da richieste cancellate (es. cambio rotta)
    const isCancelledRequest = action.error && action.error.cancelled
    if (isCancelledRequest) {
      return next(action)
    }

    const errorStatus = action.error && action.error.status
    const blockedMfaCodes = ['5709', 'WRONG_OTP_BLOCKED']
    const blockedMfaError = action.error && action.error.data && (
      blockedMfaCodes.includes(action.error.data.status) ||
      blockedMfaCodes.includes(action.error.data.errorCode)
    )
    const ignoreBlockedMfaError = action.payload && action.payload.ignoreBlockedMfaError
    if (blockedMfaError) {
      if (!ignoreBlockedMfaError) {
        store.dispatch(doShowPopup(flowPopupMapType.BLOCKED_MFA_MODAL))
        store.dispatch(doLogout({ stayOnPage: true, clearBiometric: true }))
      }
    } else if (errorStatus === 401) {
      handle401Error(isLoginPath, action, isLoginAppPath)
    } else if (errorStatus !== 409) {
      handleGlobalError(store, action)
    }
  }

  if (/_REQUEST/i.test(action.type)) {
    const { type, payload, meta, request, params } = action
    const isRequestAction = type.endsWith('_request') && type.startsWith('@@')
    const baseType = isRequestAction ? type.replace('_request', '') : type
    const shouldPersist =
      meta?.persistAfterShopChange === true ||
      payload?.persistAfterShopChange === true ||
      request?.persistAfterShopChange === true

    if (shouldPersist) {
      // Strategia migliorata per la persistenza:
      // 1. Per azioni MakeRequest: request contiene i params da persistere
      // 2. Per azioni custom: params contiene i dati
      // 3. Fallback su payload pulito
      let persistedPayload

      if (request && Object.keys(request).length > 0) {
        // MakeRequest action: il request contiene i parametri effettivi da persistere
        persistedPayload = request
      } else if (params && Object.keys(params).length > 0) {
        // Custom action with params (non-MakeRequest)
        persistedPayload = params
      } else if (payload && Object.keys(payload).filter(key => key !== 'loading' && key !== 'persistAfterShopChange').length > 0) {
        // Fallback to payload, but exclude loading/persistence flags
        const { loading, persistAfterShopChange, ...cleanPayload } = payload
        persistedPayload = cleanPayload
      } else {
        // Empty payload as last resort
        persistedPayload = {}
      }

      store.dispatch({
        type: persistedActionTypes.STORE_PERSISTED_ACTION,
        payload: {
          type: baseType,
          payload: persistedPayload
        }
      })
    }
  }

  return next(action)
}

function handle401Error (isLoginPath, action, isLoginAppPath) {
  if (!isLoginPath && !isLoginAppPath) {
    // const errorDataStatus = action.error && action.error.data && action.error.data.status
    const ignore401Redirect = action.payload && action.payload.ignore401Redirect
    if (!ignore401Redirect) {
      const redirectUrl = REDIRECT_PATH_LOGIN
      window.localStorage.removeItem('codeVerifier')
      window.sessionStorage.clear()
      window.location.replace(redirectUrl)
    }
  }
}

function handleGlobalError (store, action) {
  const errorCode = action.error && action.error.data && action.error.data.errorCode
  const hideErrorPopup = action.payload && action.payload.hideErrorPopup
  const genericBeErrorCode = action.error && action.error.data && action.error.data.errorCode === 'DEFAULT_ERROR'
  if (!hideErrorPopup && (!errorCode || genericBeErrorCode)) {
    store.dispatch(doShowPopup('TECHNICAL_ERROR_MODAL'))
  }
}

export default globals
